import { xhr } from "@jeffcarbine/premmio/public/modules/xhr/xhr.js";
import { EpisodeBox } from "../components/episode/episode.html.js";
import { addEventDelegate } from "@jeffcarbine/premmio/public/modules/eventDelegate/eventDelegate.js";
import { Slider } from "@jeffcarbine/premmio/public/components/slider/slider.html.js";

const episodes = document.querySelector("#episodes"),
  _id = episodes.dataset.showid;

const success = (request) => {
  const episodesData = JSON.parse(request.response),
    slides = [];

  episodesData.forEach((episodeData, index) => {
    const episode = EpisodeBox(episodeData, false, index);

    slides.push(episode);
  });

  Materia.render(Slider({ elements: slides }), (slider) => {
    episodes.appendChild(slider);
  });
};

xhr({ path: "/episodes", body: { _id }, success });

const showAllEpisodes = () => {
  const loadAll = document.querySelector("#loadAll");

  episodes.classList.add("showAll");
  loadAll.classList.add("showAll");
};

addEventDelegate("click", "#load-all-episodes", showAllEpisodes);
